module.exports = __webpack_public_path__ + "img/img_clients14.efe60cf7.jpg";